import { fetchSigningDigestV3 } from './http'
import { SigningDigestRequest, SigningDigestResponse } from '../models/types'

// eslint-disable-next-line import/prefer-default-export
export async function fetchSigningDigest(request: SigningDigestRequest): Promise<SigningDigestResponse> {
  return fetchSigningDigestV3(request)
}
